export const buttons = {
  all: css => css`
    button[pop] {
      width: 100%;
    }
button[secondary],
  button[sec] {
    border: var(--btn-border);
    border-radius: 5rem;
    min-width: 9rem;
    background: var(--btn-sec-bg);
    color: var(--btn-pri-bg);
  }

  button[pri],
  button[primary] {
    background: var(--btn-pri-bg);
    color: var(--btn-pri-text);
    border-radius: 5rem;
    min-width: 9rem;
  }

  button[disabled] {
    border: none;
    background: var(--btn-disabled-bg, transparent);
    color: var(--btn-disabled-text, var(--c-text-understate));
  }

  button[link] {
    border: none;
    text-decoration: underline;
    background: none;
    color: var(--c-link);
  }

  button[link][secondary] {
    font-size: 1rem;
    height: 1.2rem;
    min-height: 1.2rem;
  }

  button.circle {
    color: var(--c-select);
    background-color: transparent;
    border: 2px solid var(--c-select);
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    padding: 0;
    margin: 0;
  }
.button-bar {
    display: flex;
    width: var(--button-bar-width);
    flex-flow: wrap;
    gap: 1.3rem;
    justify-content: flex-start;
    padding: var(--button-bar-padding);
    font-weight: 500;
  }

  .button-bar button {
    border: 2px solid transparent;
    background: var(--btn-active-bg);
    border-radius: var(--input-radius);
    box-shadow: var(--input-shadow);
  }

  .button-bar button[active] {
    background: var(--btn-active-bg);
    border: 2px solid var(--btn-active-text);
    color: var(--btn-active-text);
  }

  .button-bar > button:not(:first-child) {
    /* border-inline-start: none; */
  }

  button {
    border: var(--btn-border);
    display: inline-block;
    font-family: var(--font-family);
    background: var(--btn-bg);
    min-height: var(--btn-min-height);
    font-size: var(--btn-text-size);
    margin: var(--btn-margin);
    color: var(--input-fg);
  }

  button[doublesize] {
    height: calc(1.5 * var(--btn-min-height));
  }

  button[active] {
    background: var(--c-bg-normal);
  }
 
  button.with-note {
    height: auto;
    color: var(--c-text);
    text-align: start;
    display: block;
    width: 100%;
  }
  
  span.button-note{
    display: block;
    font-size: var(--btn-note-text-size);
    color: var(--c-header-text-not-selected);
  }
  `,

  mobile(css) {
    return this.all(css);
  },

  dekstop: css => css`
  ${buttons.all(css)}
  .button-bar {
    display: flex;
    flex-flow: unset;
    width: fit-content;
    gap: 1.3rem;
    padding: 0 0;
  }
  .button-bar button {
    border: 2px solid transparent;
    border-radius: var(--input-radius);
    box-shadow: var(--input-shadow);
  }

  .button-bar button[active] {
    background: var(--btn-active-bg);
    border: 2px solid var(--btn-active-text);
    color: var(--btn-active-text);
  }
  .button-bar button:hover {
    background-color: var(--btn-hover);
  }
  .button-bar > button:not(:first-child) {
    /* border-inline-start: none; */
  }
  #controls button {
    max-width: 169px;
    padding: 3rem 1rem;
    flex-basis: fit-content;
  }

  button[doublesize] {
    height: calc(1.5 * var(--btn-min-height));
  }

  button[active] {
    background: var(--c-bg-normal);
  }
  `,
};